import { __assign, __rest } from "tslib";
import classNames from 'classnames';
import React from 'react';
import { components } from 'react-select';
import styles from './components.scss';
function override(overrides) {
    return __assign(__assign({}, components), overrides);
}
var NoOp = function () { return null; };
var empty = function () { return ({}); };
function getComponents(modifier) {
    return override(__assign(__assign({}, components), { ClearIndicator: NoOp, DropdownIndicator: NoOp, IndicatorSeparator: NoOp, IndicatorsContainer: NoOp, SelectContainer: function (props) {
            var _a;
            return (
            // @ts-ignore
            React.createElement("div", __assign({ className: classNames(props.className, styles.selectContainer, (_a = {},
                    _a[styles[modifier]] = !!modifier,
                    _a)) }, props.innerProps), props.children));
        }, Control: function (props) {
            var _a;
            return (React.createElement("div", __assign({ ref: props.innerRef, className: classNames(props.className, styles.control, (_a = {},
                    _a[styles.controlFocused] = props.isFocused,
                    _a[styles.controlEmpty] = !props.hasValue,
                    _a)) }, props.innerProps), props.children));
        }, Input: function (_a) {
            var className = _a.className, isDisabled = _a.isDisabled, isHidden = _a.isHidden, props = __rest(_a, ["className", "isDisabled", "isHidden"]);
            return (React.createElement(components.Input, __assign({}, props, { isDisabled: isDisabled, isHidden: isHidden, getStyles: empty, className: classNames(className, styles.input) })));
        }, SingleValue: function (_a) {
            var className = _a.className, children = _a.children;
            return (React.createElement("div", { className: classNames(className, styles.singleValue) }, children));
        }, ValueContainer: function (_a) {
            var className = _a.className, children = _a.children;
            return (React.createElement("div", { className: classNames(className, styles.valueContainer) }, children));
        }, Placeholder: function (_a) {
            var className = _a.className, children = _a.children;
            return (React.createElement("div", { className: classNames(className, styles.placeholder) }, children));
        }, Menu: function (_a) {
            var _b;
            var className = _a.className, children = _a.children, innerProps = _a.innerProps, props = __rest(_a, ["className", "children", "innerProps"]);
            return (React.createElement("div", __assign({ className: classNames(className, styles.menu, (_b = {},
                    _b[styles[modifier]] = !!modifier,
                    _b)), ref: props.innerRef }, innerProps), children));
        }, MenuList: function (_a) {
            var innerRef = _a.innerRef, children = _a.children, className = _a.className, selectProps = _a.selectProps, options = _a.options;
            var hasSuggestedOptions = Boolean(selectProps.defaultOptions) &&
                !selectProps.inputValue &&
                options.length > 0;
            return (React.createElement("div", { ref: innerRef, className: classNames(className, styles.menuList) },
                hasSuggestedOptions && (React.createElement("div", { className: styles.suggestionsLabel }, selectProps.defaultOptionsLabel)),
                children));
        }, Option: function (props) {
            var _a;
            return (React.createElement("div", __assign({ ref: props.innerRef, className: classNames(props.className, styles.option, (_a = {},
                    _a[styles.optionDisabled] = props.isDisabled,
                    _a[styles.optionFocused] = props.isFocused,
                    _a[styles.optionSelected] = props.isSelected,
                    _a)) }, props.innerProps), props.children));
        } }));
}
export default getComponents();
export { getComponents };
//# sourceMappingURL=components.js.map